declare namespace $ {

	export class $mol_icon_marker extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=marker.view.tree.d.ts.map